import * as React from "react";
import { CloseButtonView } from "../buttons/CloseButtonView";
import "./modalStyles.css";
export var InfoModal = function (_a) {
    var text = _a.text, onClose = _a.onClose;
    return (React.createElement("div", { className: "modal-container" },
        React.createElement("p", { className: "info-text" }, text),
        React.createElement(CloseButtonView, { onClose: onClose })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/modals/InfoModal.tsx
// module id = 15
// module chunks = 1